import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, ContentPanel, DataTable, DataTableContainer, InfiniteScroll, Text } from '@hopskipdrive/react-components';
import { variables } from '@rideiq/shared/components/variables';

import { useInfiniteTableScroll } from '../../../hooks/useInfiniteTableScroll';
import { useNavigation } from '../../../shared/hooks/useNavigation';

import { useRemovedRiders } from './useRemovedRiders';
import { useRemovedRidersTableColumn } from './useRidesTableColumns ';

export const RemovedRidersTable = () => {
  const { pageParams, resetParams, handlePagination } = useInfiniteTableScroll();
  const { rides, rideCount, isFetching, fetchRemovedRiderRides } = useRemovedRiders();
  const tableHeightOffset = variables.headingHeights.withTitleTabs + 6;
  const { navigateTo } = useNavigation();
  const [searchParams] = useSearchParams();
  const date = searchParams.get('fromDate');
  const query = searchParams.get('q');

  const firstUpdate = useRef(true);
  const columns = useRemovedRidersTableColumn({
    reset: () => fetchRemovedRiderRides({ ...pageParams, ...Object.fromEntries(searchParams.entries()) }),
  });

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;

      return;
    }
    resetParams();
  }, [date, query]);

  useEffect(() => {
    date && fetchRemovedRiderRides({ ...pageParams, ...Object.fromEntries(searchParams.entries()) });
  }, [pageParams]);

  return (
    <ContentPanel>
      <DataTableContainer heightOffset={tableHeightOffset} minWidth="1158px">
        <InfiniteScroll
          itemCount={rideCount}
          pageNumber={pageParams.page}
          perPage={pageParams.perPage}
          handleNextPage={handlePagination}
        >
          <DataTable
            isLoading={isFetching}
            groupedRows={rides}
            handleRowClick={({ slug }) =>
              navigateTo(`/rides/${slug}`, { tab: 'removed', query: searchParams.toString() })
            }
            href={({ slug }) => `/rides/${slug}`}
            columns={columns}
            noRecordsMessage={getNoRidesMessage(tableHeightOffset)}
            noRecordsForGroupMessage={getNoRidesOnDateMessage()}
          />
        </InfiniteScroll>
      </DataTableContainer>
    </ContentPanel>
  );
};

const getNoRidesOnDateMessage = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="26px">
      <Text noWrap>{'No rides on this date'}</Text>
    </Box>
  );
};

const getNoRidesMessage = (tableHeightOffset) => {
  const minHeight = window.innerHeight - tableHeightOffset - variables.tableHeadHeight;

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight={minHeight}>
      <Text textColor="secondaryText" textAlign="center">
        Sorry, no rides have a rider removed for this account yet.
      </Text>
    </Box>
  );
};
